import { useEffect, useRef } from 'react';

const INACTIVITY_LIMIT = 10 * 60 * 1000; // 10 minutos

export const useInactivityTimeout = (loginPath = '/login', onExpire = null) => {
    const timerRef = useRef(null);
    const callbackRef = useRef(null);

    // Siempre actualizado en cada render
    callbackRef.current = onExpire || (() => {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('user_type');
        sessionStorage.removeItem('tenant_name');
        window.location.replace(loginPath);
    });

    useEffect(() => {
        const reset = () => {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => callbackRef.current(), INACTIVITY_LIMIT);
        };

        const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];

        reset(); // arranca el timer al montar

        events.forEach(e => window.addEventListener(e, reset, { passive: true }));

        return () => {
            clearTimeout(timerRef.current);
            events.forEach(e => window.removeEventListener(e, reset));
        };
    }, []);
};
